export enum DeviceStatus {
    broken = 'broken',
    homeExamination = 'homeExamination',
    inStock = 'inStock',
    internalUse = 'internalUse',
    issued = 'issued',
    lost = 'lost',
    returnToProvider = 'returnToProvider',
    sentForRepair = 'sentForRepair',
    withPatient = 'withPatient',
    writtenOff = 'writtenOff',
}
